import {StatisticKey} from 'topmeteo/consent/keys';

import GTM from './google-tag-manager';

window.TopMeteoConsent.onGranted(StatisticKey, () => {
    window.dataLayer = window.dataLayer || [];

    /* gtag commands only take effect when pushed as an arguments object, not as an array */
    /* eslint-disable-next-line prefer-rest-params */
    function gtag() { window.dataLayer.push(arguments); }

    gtag('consent', 'default', {
        analytics_storage: 'granted',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
    });
    GTM(window, document, window.GoogleTagManagerIdentifier || null);
});
